import { Tabs } from "expo-router";
import { StyleSheet, useWindowDimensions, View } from "react-native";
import { Text, useTheme, useThemedStyles } from "~/components/ui";
import { fonts, type ThemeColors } from "~/styles/tokens";

function TabIcon({
  emoji,
  focused,
  label,
}: {
  emoji: string;
  focused: boolean;
  label: string;
}) {
  const { colors } = useTheme();
  const styles = useStyles();
  return (
    <View style={styles.tabIcon}>
      <Text style={styles.tabEmoji}>{emoji}</Text>
      <Text
        style={[
          styles.tabLabel,
          { color: focused ? colors.primary : colors.muted },
        ]}
        numberOfLines={1}
      >
        {label}
      </Text>
    </View>
  );
}

export default function TabsLayout() {
  const styles = useStyles();
  const { width } = useWindowDimensions();
  // Keep the tab buttons within the content column on wide screens.
  const inset = Math.max(0, (width - 680) / 2);
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarStyle: [styles.tabBar, { paddingHorizontal: inset }],
        tabBarShowLabel: false,
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          tabBarIcon: ({ focused }) => (
            <TabIcon emoji="🏠" focused={focused} label="Home" />
          ),
        }}
      />
      <Tabs.Screen
        name="recipes"
        options={{
          tabBarIcon: ({ focused }) => (
            <TabIcon emoji="📖" focused={focused} label="Recipes" />
          ),
        }}
      />
      <Tabs.Screen
        name="starter"
        options={{
          tabBarIcon: ({ focused }) => (
            <TabIcon emoji="🫙" focused={focused} label="Starter" />
          ),
        }}
      />
      <Tabs.Screen
        name="profile"
        options={{
          tabBarIcon: ({ focused }) => (
            <TabIcon emoji="👤" focused={focused} label="Profile" />
          ),
        }}
      />
    </Tabs>
  );
}

const useStyles = () => useThemedStyles(makeStyles);

const makeStyles = (c: ThemeColors) =>
  StyleSheet.create({
    tabBar: {
      backgroundColor: c.surface,
      borderTopColor: c.border,
      borderTopWidth: 1,
      height: 76,
      paddingBottom: 10,
      paddingTop: 10,
    },
    tabIcon: {
      alignItems: "center",
      justifyContent: "center",
      width: 64,
      gap: 3,
    },
    tabEmoji: {
      fontSize: 20,
      lineHeight: 24,
    },
    tabLabel: {
      fontFamily: fonts.bodySemibold,
      fontSize: 10,
      lineHeight: 13,
      letterSpacing: 0.3,
    },
  });
